<template>
  <div>
    <!-- 轮播 -->
    <div id="col">
      <a-carousel style="height: 500px" v-if="banners" autoplay>
        <div v-for="(banner, index) in banners" :key="index" style="height: 500px">
          <div class="w-full bg-center bg-cover" :style="{
            backgroundImage: `url(${assetURL(banner.img_src)})`,
            height: '500px',
          }" @click="openBlank(banner.url_data, banner.name)"></div>
        </div>
      </a-carousel>
    </div>
    <!-- 轮播图 -->
    <Swiper></Swiper>

    <div class="picture_flow">
      <div class="flow_top">
        <div class="">全流程线上一站式办理7*24小时  服务不打烊</div>
        <br/>
        <div class=""></div>
       <div class="">安全 高效 合规</div>
        <br/>
        <div class=""></div>
        <span>- 只需五步即可出函成功 -</span>
      </div>
      <br/>
      <div class="picture_content">
        <div class="pt-6 mt-10 step-form-form">
            <a-steps :current="-1">
              <a-step title="填写信息" />
              <a-step title="金融机构审核" />
              <a-step title="签署合同" />
              <a-step title="支付保费" />
              <a-step title="完成" />
            </a-steps>
          </div>
      </div>
    </div>

    <!-- 合作机构组件保留，继续隐藏且不挂载。 -->
    <IntroduceUint v-if="false"></IntroduceUint>
  </div>
</template>
<script>
import Swiper from '@/views/index/IntroduceSwiper/index';
import IntroduceUint from '@/views/index/introduceUnit/index';

export default {
  name: 'Index',
  components: { Swiper, IntroduceUint },
  data() {
    return { banners: [] };
  },
  mounted() {
    this.getBanners();
  },
  methods: {
    async getBanners() {
      try {
        const response = await fetch('https://admin.jdbsk.com/api/v1/jdb_carousels');
        if (!response.ok) throw new Error('网络响应异常');
        const data = await response.json();
        this.banners = (data.result && data.result.data) || [];
      } catch (error) {
        console.error('轮播图加载失败:', error);
      }
    },
    openBlank(url, name) {
      url && window.open(url, name, '__blank');
    },
    assetURL(source) {
      const value = String(source || '');
      return /^https?:\/\//i.test(value) ? value : this.$ossUrl + value;
    },
  },
};
</script>
<style lang="less" scoped>


.step-form-form {
  width: 950px;
  margin: 0 auto 0 auto;
}



.picture_flow {
  min-width: 1400px;
  height: 450px;
  width: 100%;
  position: relative;
  background: #fff;
  text-align: center;
  background-size: cover;
}

.flow_top {
  font: normal 28px Microsoft YaHei;
  color: #222;
  padding-top: 123px;
}

.picture_content {
  display: flex;
  align-items: center;
  width: 100%;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

</style>
